import { Drawer, Image, message } from 'antd';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import MessageDrawerDiv from './styles';
import { AdminMessageApi} from "gmrfid-service-message-api-manager"



const messageDrawer = (props) => {
  const [active, setActive] = useState('all');
  const [more, setMore] = useState(true);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [childrenDrawer, setChildrenDrawer] = useState(false);
  const [childrenDrawerData, setChildrenDrawerData] = useState({});

  const getData = (page) => {
    const param = {
      page,
      type: active === 'all' ? null : active,
      size: 10,
    };
    AdminMessageApi.getServiceMsgList({ param }).then((res) => {
      if (res) {
        const newData = page === 0 ? res.data.content : data.concat(res.data.content);
        setPage(page + 1);
        if (newData.length >= res.data.totalElements) {
          setMore(false);
        }
        setData(newData);
      }
    });
  };

  useEffect(() => {
    // getData(0);
  }, [active]);

  const getStr = (type) => {
    switch (type) {
      case 'VERIFYING':
        return '您已成功提交了店铺认证，请耐心等待审核结果 ';
      case 'VERIFIED':
        return '您的店铺论证已通过，立即去上加商品进行交易吧';
      case 'ORDER_WAIT':
        return '待接单';
      case 'ORDER_CLOSE':
        return '订单关闭';
      case 'ORDER_SUCCESS':
        return '交易成功';
      default:
        return '';
    }
  };

  const readAllServiceMsg = () => {
    const messageForm = {
      type: active === 'all' ? null : active,
    };
    AdminMessageApi.readAllServiceMsg({ messageForm }).then((res) => {
      message.success('操作成功');
      getData(0);
    });
  };

  return (
    <MessageDrawerDiv>
      <Drawer
        visible={props.visible}
        closable={false}
        getContainer={false}
        onClose={() => props.setVisible(false)}
        width={720}
        bodyStyle={{ padding: 0 }}
        afterVisibleChange={(drawerType) => {
          if (drawerType) {
            getData(0);
          }
        }}
      >
        <div className="messageDrawerTop">
          <div className="messageDrawerTopLeft">
            <div className={`list ${active === 'all' ? 'active' : ''}`} onClick={() => setActive('all')}>
              <div className="text">全部消息</div>
              <div className="bar" />
            </div>
            <div className={`list ${active === 'SYSTEM' ? 'active' : ''}`} onClick={() => setActive('SYSTEM')}>
              <div className="text">系统消息</div>
              <div className="bar" />
            </div>
            <div className={`list ${active === 'ORDER' ? 'active' : ''}`} onClick={() => setActive('ORDER')}>
              <div className="text">交易提醒</div>
              <div className="bar" />
            </div>
          </div>
          <div className="messageDrawerRight">
            <img className="forkImg" src="/fork.png" onClick={() => props.setVisible(false)} />
          </div>
        </div>
        <div className="messageDrawerContent">
          {data.map((v) => {
            if (v.type === 'ORDER') {
              return (
                <div className="contentList" key={v.id}>
                  <div className={`listLeft ${v.state === 'UNREAD' ? 'read' : ''}`} />
                  <div className="listRight">
                    <div className="listTitle">
                      <div className="black">【{getStr(v.childType)}】</div>
                      <div className="gray">
                        {v.resourceUserName} {v.payStatusName}了&nbsp;&nbsp;
                      </div>
                      <div className="black">{v.title.length > 16 ? `${v.title.slice(0, 15)}...` : v.title}</div>
                      <div className="gray"> ，现等待商家{v.childPayStatusName}&nbsp;&nbsp;</div>
                      <div className="green">查看订单</div>
                    </div>
                    <div className="listTime">{moment(v.createDate).format('YY-MM-DD HH:mm')}</div>
                  </div>
                </div>
              );
            }
            if (v.childType) {
              return (
                <div className="contentList" key={v.id}>
                  <div className={`listLeft ${v.state === 'UNREAD' ? 'greenDot' : ''}`} />
                  <div className="listRight">
                    <div className="listTitle">
                      <div className="black">{getStr(v.childType)}</div>
                      <div className="green">&nbsp;查看认证详情</div>
                    </div>
                    <div className="listTime">{moment(v.createDate).format('YY-MM-DD HH:mm')}</div>
                  </div>
                </div>
              );
            }
            return (
              <div
                className="contentList"
                key={v.id}
                onClick={() => {
                  setChildrenDrawer(true);
                  setChildrenDrawerData(v);
                }}
              >
                <div className={`listLeft ${v.state === 'UNREAD' ? 'greenDot' : ''}`} />
                <div className="listRight">
                  <div className="listTitle">
                    <div className="black">{v.content}</div>
                  </div>
                  <div className="listTime">{moment(v.createDate).format('YY-MM-DD HH:mm')}</div>
                </div>
              </div>
            );
          })}
          <div className="more" onClick={() => (more ? getData(page) : null)}>
            {more ? '点击加载更多' : '没有更多了'}
          </div>
        </div>
        <div className="all" onClick={readAllServiceMsg}>
          全部设为已读
        </div>
      </Drawer>
      <Drawer
        width={720}
        closable={false}
        getContainer={false}
        onClose={() => {
          setChildrenDrawer(false);
          setChildrenDrawerData({});
        }}
        visible={childrenDrawer}
        bodyStyle={{ padding: 0 }}
      >
        <div className="messageDrawerTop">
          <div className="childrenDrawerRight">通知详情</div>
          <div className="messageDrawerRight">
            <img
              className="forkImg"
              src="/fork.png"
              onClick={() => {
                setChildrenDrawer(false);
                setChildrenDrawerData({});
              }}
            />
          </div>
        </div>
        <div className="childrenDrawerContent">
          <div className="childrenDrawerTitle">{childrenDrawerData.title}</div>
          <div className="childrenDrawerTips">
            <div className="tipsLeft">来源：{childrenDrawerData.resourceUserName}</div>
            <div className="tipsRight">发送时间：{moment(childrenDrawerData.createDate).format('YYYY-MM-DD')}</div>
          </div>
          <div className="childrenDrawerContentList">{childrenDrawerData.content}</div>
        </div>
      </Drawer>
    </MessageDrawerDiv>
  );
};

export default messageDrawer;
